/* Task-Management Phase 2 / L (decision L4 · Design chunk-review B1 reconcile):
 * the fixed creatable label-color palette.
 *
 * Colors are stored server-side as design-token KEYS (never a raw hex — see
 * tools/workspace.py's LABEL_COLORS, kept in lock-step with LABEL_COLOR_KEYS
 * below). This module is the ONLY place a key becomes a CSS class, so a hex
 * literal can NEVER reach the DOM and the adherence lint stays satisfied
 * end-to-end. Each key maps to a `.wsl-<key>` class in styles/workspace.css,
 * where the swatch dot resolves to a `var(--token)` fill.
 *
 * The three CREATABLE hues are the dedicated label tokens minted by the
 * design-system owner (`--teal-*`/`--rose-*`/`--steel-*`), OUTSIDE the semantic
 * set so a label never reads as a state. Red is deliberately absent (the red
 * budget reserves red for regressed / overdue / undesirable content).
 *
 * `slate` is NOT creatable (`--steel` is a distinct value — Design namespace
 * ruling, no silent rehue of the brand navy `--slate`), but `.wsl-slate` stays
 * the neutral FALLBACK swatch for an unknown/legacy stored key. */
export const LABEL_COLOR_KEYS = ['teal', 'rose', 'steel'] as const;

export type LabelColorKey = (typeof LABEL_COLOR_KEYS)[number];

/** The `.wsl-<key>` swatch class for a stored token key (slate fallback for an
 *  unknown/absent key). The returned string is always a class name — never a
 *  color value — so no raw hex can flow through here into markup. */
export function labelColorClass(key: string | undefined | null): string {
  return (LABEL_COLOR_KEYS as readonly string[]).includes(key as string)
    ? `wsl-${key}`
    : 'wsl-slate';
}
